export default "__VITE_ASSET__pQdc6a3Z__"